import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LocalStorage } from '../plugins/localStorage';
import {messages} from '../i18n';

const resources = {
  ru: {
    translation: messages.ru,
  },
  en: {
    translation: messages.en,
  },
  // добавьте другие языки здесь
};

i18n.use(initReactI18next).init({
  resources,
  lng: LocalStorage.get('locale'), // язык по умолчанию
  fallbackLng: 'en', // резервный язык
  interpolation: {
    escapeValue: false, // React уже экранирует значения
  },
});

export default i18n;
